import { AsciiRenderer } from "./AsciiRenderer";
export class App {
  constructor() {
    this.mediaManager = new AsciiRenderer();
    this.addEventListeners();
  }

  createAnimation() {}

  addEventListeners() {}
}
